import React from 'react';

const CasesIcon = (
  <svg
    width="24"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'inherit' }}
  >
    <path
      style={{ fill: 'inherit' }}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 4.313h2.813C23.244 4.313 24 5.066 24 6v10.313c0 .932-.755 1.687-1.688 1.687H1.688A1.686 1.686 0 0 1 0 16.312V6c0-.933.755-1.688 1.688-1.688H4.5V1.688C4.5.755 5.255 0 6.188 0h11.625c.932 0 1.687.755 1.687 1.688v2.625Zm-1.688-2.625H6.188v2.625h11.625V1.688ZM22.313 6v10.313H1.688V6h20.625Zm-11.156 6H9.094a.843.843 0 1 1 0-1.688h2.062V8.25a.843.843 0 1 1 1.688 0v2.063h2.062a.843.843 0 1 1 0 1.687h-2.062v2.063a.843.843 0 1 1-1.688 0V12Z"
    />
  </svg>
);

export default CasesIcon;
